/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import getObjectById from "../getObjectById";

const getObjectByArrayId = (objects_, arr_id) => {
    let result = [];
    if (Array.isArray(objects_) && Array.isArray(arr_id)) {
        for (let i = 0, length = arr_id.length; i < length; i++) {
            const obj = getObjectById(objects_, arr_id[i]);
            if (obj !== null) {
                result.push(obj);
            }
        }
    }

    return result;
};

export default getObjectByArrayId;
